/* eslint-disable react/prop-types */
/** @jsx createElement */
// noinspection ES6UnusedImports
import createElement from '../jsx/createElement';

const ConnectingBar = function ({ message }) {
  return (
    <div className="queuePositionContainer guuruConnectingBar">
      <span
        role="presentation"
        tabIndex="-1"
        aria-hidden="true"
        className="loadingBallContainer animated embeddedServiceLoadingBalls embeddedServiceLiveAgentQueuePosition"
      >
        <span
          role="presentation"
          aria-hidden="true"
          className="loadingBall first"
        />
        <span
          role="presentation"
          aria-hidden="true"
          className="loadingBall second"
        />
        <span
          role="presentation"
          aria-hidden="true"
          className="loadingBall third"
        />
      </span>
      {message && <span className="transferringText">{message}</span>}
    </div>
  );
};

export default ConnectingBar;
